import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/causes", label: "Causes" },
  { to: "/grants", label: "Grants" },
  { to: "/volunteer", label: "Volunteer" },
  { to: "/blog", label: "Stories" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-[#0A0A0C]/85 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="brand-logo">
          <span className="inline-flex h-9 w-9 items-center justify-center bg-[#E85D04] text-white font-serif-display text-base leading-none">
            JD
          </span>
          <div className="leading-tight">
            <div className="font-serif-display text-lg sm:text-xl text-white">
              John Depp Foundation
            </div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-white/40">
              Global Animal Rights
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm tracking-[0.18em] uppercase transition-colors ${
                  isActive
                    ? "text-[#E85D04]"
                    : "text-white/70 hover:text-white"
                }`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link
            to="/donate"
            data-testid="nav-donate-cta"
            className="hidden sm:inline-flex items-center gap-2 bg-[#E85D04] hover:bg-[#DC2F02] text-white px-5 py-3 text-xs tracking-[0.22em] uppercase transition-colors duration-300"
          >
            Donate Now
          </Link>
          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden text-white p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle navigation"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0A0A0C] border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-sm tracking-[0.2em] uppercase ${
                    isActive ? "text-[#E85D04]" : "text-white/80"
                  }`
                }
                end={n.to === "/"}
              >
                {n.label}
              </NavLink>
            ))}
            <Link
              to="/donate"
              data-testid="mobile-donate-cta"
              className="mt-2 inline-flex items-center justify-center bg-[#E85D04] text-white px-5 py-3 text-xs tracking-[0.22em] uppercase"
            >
              Donate Now
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
